import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  FormControlLabel,
  Checkbox,
  Switch,
} from '@material-ui/core';

import {
  setEarMarks as setEarMarksAction,
  setEarMarksAnimalSelection as setEarMarksAnimalSelectionAction,
  createPosition,
  deletePosition,
} from 'modules/brandRegistration';
import {
  HorseRightSvg,
  CattleLeftSvg,
  CattleRightSvg,
  SheepSvg,
} from 'components/livestock';
import EarSketch from './EarSketch';
import { useAnimalSelectionStyles } from '../styles';

const AnimalSelection = ({
  brandPositions,
  brandImage,
  earMarks,
  imageRegisteredPositions,
}) => {
  const dispatch = useDispatch();
  const setEarMarks = (...args) => dispatch(setEarMarksAction(...args));
  const setEarMarksAnimalSelection = (...args) => dispatch(setEarMarksAnimalSelectionAction(...args));
  const [visibleLabels, setVisibleLabels] = useState(true);
  const classes = useAnimalSelectionStyles();

  const handleSelectedPosition = (key) => {
    if (key) {
      if (brandPositions.includes(key)) {
        dispatch(deletePosition(key));
      } else {
        dispatch(createPosition(key));
      }
    }
  };

  const handleLabelVisibility = (ev) => {
    setVisibleLabels(ev.target.checked);
  };

  const handleEarSketchChange = (earMarksSketch) => {
    setEarMarks(earMarksSketch);
  };

  const handleEarSketchAnimalSelection = (ev) => {
    const value = ev.target.value || '';

    if (earMarks.animals.includes(value)) {
      setEarMarksAnimalSelection(earMarks.animals.filter((a) => a !== value));
    } else {
      setEarMarksAnimalSelection([...earMarks.animals, value]);
    }
  };

  return (
    <div className={classes.wrapper}>
      <FormControlLabel
        control={
          <Switch
            checked={visibleLabels}
            onChange={handleLabelVisibility}
            name="showLabels"
            color="primary"
          />
        }
        label="Show Labels"
      />

      <h3>Cattle Or Horse</h3>
      <div className={classes.row}>
        <div>
          <CattleLeftSvg
            selected={brandPositions}
            imageRegisteredPositions={imageRegisteredPositions}
            onSelect={handleSelectedPosition}
            image={brandImage.imageUrl}
            visibleLabels={visibleLabels}
          />
        </div>
        <div>
          <CattleRightSvg
            selected={brandPositions}
            imageRegisteredPositions={imageRegisteredPositions}
            onSelect={handleSelectedPosition}
            image={brandImage.imageUrl}
            visibleLabels={visibleLabels}
          />
        </div>
      </div>
      <div className={classes.rowThree}>
        <div>
          <h3>Sheep</h3>
          <SheepSvg
            selected={brandPositions}
            imageRegisteredPositions={imageRegisteredPositions}
            onSelect={handleSelectedPosition}
            image={brandImage.imageUrl}
            visibleLabels={visibleLabels}
          />
        </div>
        <div>
          <h3>Horse Right Jaw</h3>
          <div>
            <HorseRightSvg
              selected={brandPositions}
              imageRegisteredPositions={imageRegisteredPositions}
              onSelect={handleSelectedPosition}
              image={brandImage.imageUrl}
              visibleLabels={visibleLabels}
            />
          </div>
        </div>
        <div>
          <h3>Cattle or Sheep Ear Marks</h3>
          <EarSketch
            onChange={handleEarSketchChange}
            defaultValue={earMarks.sketch}
          />
          <div>
            <FormControlLabel
              control={<Checkbox
                name="sheep"
                color="primary"
                value="sheep"
              />}
              onChange={handleEarSketchAnimalSelection}
              checked={earMarks.animals.includes('sheep')}
              label="Sheep"
            />
            <FormControlLabel
              control={<Checkbox
                name="cattle"
                color="primary"
                value="cattle"
              />}
              onChange={handleEarSketchAnimalSelection}
              checked={earMarks.animals.includes('cattle')}
              label="Cattle"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

AnimalSelection.propTypes = {
  brandPositions: PropTypes.array.isRequired,
  imageRegisteredPositions: PropTypes.array.isRequired,
  brandImage: PropTypes.object.isRequired,
  earMarks: PropTypes.object.isRequired,
};

export default AnimalSelection;
